import {
  StrapiBlogEditorContent,
  StrapiBlogPriceHistory,
  StrapiBlogProductOffers,
  StrapiPagination,
} from './strapi/types';

export const enum BlogEndpoints {
  GetPost = 'blog/getPost',
  GetAllPosts = 'blog/getAllPosts',
  GetAuthorWithPosts = 'blog/getAuthorWithPosts',

  BlackFridayPageContent = 'bf/getBlackFridayPageContent',

  GetCashbackitems = 'blog/getCashbackItems',
}

export type BlogPriceHistory = {
  id: StrapiBlogPriceHistory['__typename'];
  productId: StrapiBlogPriceHistory['idDoProduto'];
};

export type BlogProductOffers = {
  id: StrapiBlogProductOffers['__typename'];
  productId: StrapiBlogProductOffers['idDoProduto'];
};

export type BlogTextContent = {
  id: StrapiBlogEditorContent['__typename'];
  content: StrapiBlogEditorContent['editor'];
};

export type BlogAuthor = {
  id: string;
  name: string;
  bio: string;
  linkedin: string | null;
  instagram: string | null;
  avatar: string;
};

export type BlogBasicAuthor = Pick<BlogAuthor, 'id' | 'name' | 'avatar'>;

export type BlogPost = {
  id: string;
  title: string;
  description: string;
  publishedAt: string;
  slug: string;
  author: BlogBasicAuthor;
  category: BlogCategory;
  cover: string;
};

export type BlogPostContents =
  | BlogPriceHistory
  | BlogProductOffers
  | BlogTextContent
  | undefined;

export type BlogPostWithContent = BlogPost & {
  contents: BlogPostContents[];
};

export type BlogPagination = StrapiPagination;

export type AllBlogPostsWithPagination = {
  posts: BlogPost[];
  pagination: BlogPagination | null;
};

export type BlogCategory = {
  id: string;
  name: string;
  slug: string;
};

export type BlogAuthorWithPosts = {
  author: BlogAuthor;
  posts: BlogPost[];
  pagination: BlogPagination | null;
};

/**
 * Black friday ...
 */

export type BlackFridayFaqItem = {
  id: string;
  question: string;
  answer: string;
};

export type BlackFridayFaq = {
  title: string;
  subtitle: string;
  items: BlackFridayFaqItem[];
};

export type BlackFridayPageContent = {
  mainTitle: string;
  mainDescription: string;
  faq: BlackFridayFaq;
};
